// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2KxV_H","isFlush":"isFlush-1gDAJl"};